// Google Tag Manager utility functions
export const GTM_ID = 'GTM-ND37T425';

// Track page views
export const trackPageView = (url) => {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push({
      event: 'page_view',
      page_location: url
    });
  }
};

// Track custom events
export const trackEvent = (eventName, parameters = {}) => {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push({
      event: eventName,
      ...parameters
    });
  }
};

// Track form submissions
export const trackFormSubmission = (formName, formData = {}) => {
  trackEvent('form_submit', {
    form_name: formName,
    ...formData
  });
};

// Track button clicks
export const trackButtonClick = (buttonName, additionalData = {}) => {
  trackEvent('button_click', {
    button_name: buttonName,
    ...additionalData
  });
};
